import {Layout, Typography, Anchor} from 'antd';
import React from 'react';
import {useState} from 'react';
import appColors from '../../style/theme';
import POCBackLogic from './POCBack';
import POCSectionsLogic from './POCSections';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const {Text} = Typography;
const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};
const POCPage = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#POCBack') {
      setBackI(appColors['ColorA']);
      setBackII('transparent');
    } else if (key === '#POCSec') {
      setBackI('transparent');
      setBackII(appColors['ColorA']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#POCBack' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorA'], fontSize: '3vh'}}>Overview</Text></Content>}/>
          <Link href='#POCSec' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorA'], fontSize: '2.3vh'}}>Section Summary</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorA'], pointerEvents: 'none', fontSize: '2vh', top: '70vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> P &nbsp;&nbsp; &nbsp; C <br/> R &nbsp; &nbsp;&nbsp; O<br/>O &nbsp; &nbsp;&nbsp; N<br/>O &nbsp;&nbsp;&nbsp; &nbsp;C<br/>F &nbsp; &nbsp; &nbsp; E<br/>&nbsp; &nbsp; &nbsp;&nbsp;   &nbsp; P<br/>O &nbsp;&nbsp;&nbsp;&nbsp;T<br/>F &nbsp; &nbsp; &nbsp; &nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='POCBack'>
              <POCBackLogic/>
            </div>
            <div id='POCSec'>
              <POCSectionsLogic/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default POCPage;
